import React from 'react';

import { CSVLink } from 'react-csv';

import Excel from '../../assets/excel.png';
import ImageColorChanger from '../../utils/imageColorChanger';

import './styles.scoped.css';

const ExportCsvButton = ({
  data,
  filename,
  onClick,
  brandColor,
  style = {},
}) => {
  const iconStyle = { ...style, cursor: 'pointer' };

  const icon = brandColor ? (
    <ImageColorChanger
      src={Excel}
      style={iconStyle}
      alt="export-to-excel"
      brandColor={brandColor}
    />
  ) : (
    <img src={Excel} alt="export-to-excel" style={iconStyle} />
  );

  if (data && filename) {
    return (
      <CSVLink className="export-csv-button" filename={filename} data={data}>
        {icon}
      </CSVLink>
    );
  }

  return (
    <button type="button" className="export-csv-button" onClick={onClick}>
      {icon}
    </button>
  );
};

export default ExportCsvButton;
